module.exports = __webpack_public_path__ + "static/media/photo265.ed2575c2.jpg";